/* tslint:disable */
/* eslint-disable */
/**
 * Client Signup API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InvitationContextResponseInvitationInviter
 */
export interface InvitationContextResponseInvitationInviter {
    /**
     * The first name of the inviter
     * @type {string}
     * @memberof InvitationContextResponseInvitationInviter
     */
    firstName?: string;
    /**
     * The last name of the inviter
     * @type {string}
     * @memberof InvitationContextResponseInvitationInviter
     */
    lastName?: string;
}

/**
 * Check if a given object implements the InvitationContextResponseInvitationInviter interface.
 */
export function instanceOfInvitationContextResponseInvitationInviter(value: object): value is InvitationContextResponseInvitationInviter {
    return true;
}

export function InvitationContextResponseInvitationInviterFromJSON(json: any): InvitationContextResponseInvitationInviter {
    return InvitationContextResponseInvitationInviterFromJSONTyped(json, false);
}

export function InvitationContextResponseInvitationInviterFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvitationContextResponseInvitationInviter {
    if (json == null) {
        return json;
    }
    return {
        
        'firstName': json['firstName'] == null ? undefined : json['firstName'],
        'lastName': json['lastName'] == null ? undefined : json['lastName'],
    };
}

export function InvitationContextResponseInvitationInviterToJSON(value?: InvitationContextResponseInvitationInviter | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'firstName': value['firstName'],
        'lastName': value['lastName'],
    };
}

